import {Modal} from "react-native";
import Page from "@/lib/components/Page";
import UserProfilePage from "@/lib/components/UserProfilePage";
import ActionButton from "@/lib/components/ActionButton";
import Split from "@/lib/components/Split";
import Center from "@/lib/components/Center";
import {UserAvatar} from "@/lib/types";
import {useRouter} from "expo-router";

type Props = {
    avatar: UserAvatar,
    visible: boolean,
    onRequestClose: () => any,
}

export default function AvatarModal({avatar, visible, onRequestClose}: Props) {
    const router = useRouter();

    return (

        <Modal
            visible={visible}
            allowSwipeDismissal={true}
            presentationStyle={"pageSheet"}
            animationType={"slide"}
            onRequestClose={onRequestClose}
        >
            <Page>
                <Center>
                    <UserProfilePage username={avatar.username} detailed={false}/>
                    <Split left={
                        <ActionButton title={"Lukk"} onPress={onRequestClose}/>
                    } right={
                        <ActionButton title={"Vis hele profilen"} icon={"relation"} onPress={() => {
                            router.navigate(`/u/profile/${avatar.username}`);
                            onRequestClose();
                        }}/>
                    }/>
                </Center>
            </Page>
        </Modal>
    )
}